import { get } from 'lodash';

import * as Interfaces from 'Interfaces/Interfaces';

const root = (state: Interfaces.AppState) => get(state, 'sitePickerState');

export const getSiteId = (state: Interfaces.AppState): string | null => get(root(state), 'siteId');
